import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"pen-brush"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M21.5 7.00049L17 2.50049L6 13.5L10.5 18L21.5 7.00049Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M2.99902 21.0007L2.99962 17.3287C2.99971 16.7984 3.21041 16.2898 3.58541 15.9148L5.99976 13.5L10.4998 18L8.08554 20.4149C7.71047 20.79 7.20176 21.0007 6.67132 21.0007H2.99902Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M10.4998 18L5.99976 13.5M2.99962 17.3287L2.99902 21.0007H6.67132C7.20176 21.0007 7.71047 20.79 8.08554 20.4149L21.4998 7.00049L16.9998 2.50049L3.58541 15.9148C3.21041 16.2898 2.99971 16.7984 2.99962 17.3287Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const PenBrush = Vue.extend<IconProps>({
  name: 'PenBrushIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'pen-brush',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default PenBrush;
